// src/popupTheme.js
//
// The colours a popup is drawn in, by theme name. Both the storefront, which
// shows popups on every page, and the admin popups tab, which previews them,
// read them from here — so the storefront need not load the admin tab, and
// everything that tab imports, just to colour a banner.

/** Theme styling dictionary for live preview and storefront rendering */
export const getThemePalette = (themeName) => {
  switch (themeName) {
    case 'gold':
      return {
        bg: '#fffbeb',
        border: '#fde68a',
        badgeBg: '#fef3c7',
        badgeText: '#92400e',
        accent: '#d97706',
        ctaBg: '#d97706',
        ctaText: '#ffffff',
        ctaHover: '#b45309',
      };
    case 'info':
      return {
        bg: '#eff6ff',
        border: '#bfdbfe',
        badgeBg: '#dbeafe',
        badgeText: '#1e40af',
        accent: '#2563eb',
        ctaBg: '#2563eb',
        ctaText: '#ffffff',
        ctaHover: '#1d4ed8',
      };
    case 'warning':
      return {
        bg: '#fff7ed',
        border: '#fed7aa',
        badgeBg: '#ffedd5',
        badgeText: '#9a3412',
        accent: '#ea580c',
        ctaBg: '#ea580c',
        ctaText: '#ffffff',
        ctaHover: '#c2410c',
      };
    case 'dark':
      return {
        bg: '#0f172a',
        border: '#334155',
        badgeBg: '#1e293b',
        badgeText: '#94a3b8',
        accent: '#38bdf8',
        ctaBg: '#38bdf8',
        ctaText: '#0f172a',
        ctaHover: '#0284c7',
        textPrimary: '#f8fafc',
        textSecondary: '#cbd5e1',
      };
    case 'primary':
    default:
      return {
        bg: '#ecfdf5',
        border: '#a7f3d0',
        badgeBg: '#d1fae5',
        badgeText: '#065f46',
        accent: '#059669',
        ctaBg: '#059669',
        ctaText: '#ffffff',
        ctaHover: '#047857',
      };
  }
};
